import React, { Component, useEffect, useState } from "react";
import { Button, Icon, message, Modal, Select, Spin } from "antd";
import { TRANSFER__BFILES_API_V3, VONBOARDERS_USERS_LIST_API_URL } from "../../../utils/Api_enums";
import { Translate } from "react-translated";
import axios from "axios";
import F from "../../../Functions";

const Option = Select.Option;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const TransferAllBfiles = (props) => {

    const [unlinkModalState, setUnlinkModalState] = useState({
        loading: true,
        users: [],
        agent: "",
    });

    useEffect(() => {
        const loadNewUsers = async () => {
            let api = `${VONBOARDERS_USERS_LIST_API_URL}?rolename_param=both`
            try {
                const { data } = await axios.get(api);
                if (Array.isArray(data["Virtual On-Boarding1"])) {
                    // remove current selected row user from data 
                    const updatedUsersList = data["Virtual On-Boarding1"].filter((user) => user.id !== props.user.id);

                    setUnlinkModalState((prevState) => ({
                        ...prevState,
                        // users: data["Virtual On-Boarding1"],
                        users: updatedUsersList,
                        agent: ""
                    }));
                }
            } catch (error) {
                console.log("error", error);
            } finally {
                setUnlinkModalState((prevState) => ({
                    ...prevState,
                    loading: false,
                }));
            }
        };

        loadNewUsers();

    }, []);

    const save = async () => {
        const { agent } = unlinkModalState;
        const { user } = props;

        const res = await axios.post(TRANSFER__BFILES_API_V3, {
            user_id: user.id,
            new_user_id: agent,
        })

        if (res.data && res.data.success) {
            message.success(F.translate(res.data.results || ""));
            props.hideModal();
            props.refresh();
            setUnlinkModalState((prevState) => ({
                ...prevState,
                loading: false,
            }));
        } else {
            message.error(F.translate(`Can't unlink the user.`));
            setUnlinkModalState((prevState) => ({
                ...prevState,
                loading: false,
            }));
        }

    }

    const renderDescription = () => {
        return (
            <p>
                <span>
                    {`Select a Follow-Up Specialist to move all the remaining B Files.`}
                </span>
            </p>
        );
    };


    return (

        <Modal
            title="Transfer All B Files"
            visible={props.showModal}
            onCancel={props.hideModal}
            footer={
                <div>
                    <Button type="primary"
                        className="borderRadius-28 bg-164897"
                        disabled={unlinkModalState.agent === ""}
                        onClick={() => save()}>
                        <Translate text={`Transfer Ownership`} />
                    </Button>
                    <Button
                        className="borderRadius-28"
                        onClick={() => {
                            props.hideModal();
                            setUnlinkModalState((prevState) => ({
                                ...prevState,
                                loading: false,
                                agent: "",
                            }));
                        }}
                    >
                        <Translate text={`Cancel`} />
                    </Button>
                </div>
            }
        >
            <Spin indicator={antIcon} spinning={unlinkModalState.loading}>
                <div className="formBox">
                    <div>
                        {renderDescription()}
                    </div>
                    <div style={{ marginBottom: 10 }}>
                        <label style={{ fontWeight: 600 }}>
                            <Translate
                                text={"Who do you want to transfer the ownership to?"}
                            />
                            <span className="asteriskIcon">*</span>
                        </label>
                        <Select
                            defaultValue={""}
                            value={unlinkModalState.agent}
                            style={{ width: "100%" }}
                            onChange={(val) => {
                                setUnlinkModalState((prevState) => ({
                                    ...prevState,
                                    agent: val,
                                }));
                            }}
                        >
                            <Option value={""}>
                                <Translate text={"Select Follow-Up Specialist"} />
                            </Option>
                            {unlinkModalState.users.map((user, i) => (
                                <Option key={i} value={user.id}>
                                    {user.name}
                                </Option>
                            ))}
                        </Select>
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}

export default TransferAllBfiles;


// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/parts/TransferAllBfiles.js